import React, { useState } from "react";
import {
  TextField as MuiTextField,
  IconButton,
  InputAdornment,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export const PasswordField = ({ field, value, onChange }) => {
  const [showPassword, setShowPassword] = useState(false);
  //  const togglePasswordVisibility = () => {
  //     setShowPassword(!showPassword);
  //   };
  const handleToggleVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const isPasswordField = field?.type === "password";
  return (
    <MuiTextField
      type={isPasswordField && !showPassword ? "password" : "text"}
      label={field.label}
      value={value || ""}
      onChange={(e) => onChange(field.name, e.target.value)}
      required={field.required}
      fullWidth
      InputProps={
        isPasswordField
          ? {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleToggleVisibility} edge="end">
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }
          : undefined
      }
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: "10px", // Customize border radius here
        },
        "& .MuiInputLabel-root": {
          fontSize: "14px", // Customize font size here
        },
      }}
    />
  );
};
